!(function () {
    "use strict";
    const t = "[data-section-id]";
    customElements.get("recently-viewed") ||
        customElements.define(
            "recently-viewed",
            class extends HTMLElement {
                constructor() {
                    super(),
                        (this.section = this.closest(t)),
                        (this.howManyToShow = parseInt(this.dataset.limit) || 3),
                        (this.target = this.dataset.target),
                        (this.wrapperId = this.dataset.wrapperId || this.id);
                }
                connectedCallback() {
                    console.log("Shopify.Products:", Shopify?.Products?.hasProducts);
                    let hasPro = Shopify?.Products?.hasProducts;
                    console.log(this, "section", this.howManyToShow)
                    if(hasPro == true)
                    {
                        console.log("checked")
        const section = this.closest('[data-section-id]');
console.log(section)
        const recentTabBtn = section?.querySelector('.tab-link-1');
        const relatedTabBtn = section?.querySelector('.tab-link-0');

        const recentTab = section?.querySelector('.tab-link__recent');
        const relatedTab = section?.querySelector('.tab-content-0');
recentTab?.click();
console.log("ok" , recentTab)
                    }
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: this.howManyToShow,
                        wrapperId: this.wrapperId,
                        section: this.section,
                        target: this.target,
                        onComplete: () => {
                            

    // 👉 If NO recently viewed products
    // if (recentItems.length > 0) {
        
        // // remove recent active
        // recentTabBtn?.classList.remove('current');
        // recentTab?.classList.remove('current');

        // // activate related
        // relatedTabBtn?.classList.add('current');
        // relatedTab?.classList.add('current');
    // }
                            this.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded", { bubbles: !1 }));
                        },
                    });
                }
            }
        );
})();
